import React from "react";

import wp from "../tools/wp-endpoint.js";
import Spinner from "../tools/spinner.js";

const adjust = function (html) {
  return html.replace(/<h2/g, "<h3").replace(/<\/h2/g, "</h3").replace(/<h1/g, "<h3").replace(/<\/h1/g, "</h3");
};

export default class Aktuelles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
    };

    wp.posts()
      .perPage(100)
      .categories(4)
      .embed()
      .then(
        function (data) {
          this.setState({
            posts: data,
          });
        }.bind(this)
      );
  }

  render() {
    return (
      <div className="blog-content">
        {this.state.posts.length == 0 && <Spinner />}
        {this.state.posts.map(function (post, index) {
          return (
            <div className="post" key={index}>
              <h2 dangerouslySetInnerHTML={{ __html: adjust(post.title.rendered) }} />
              <div className="content" dangerouslySetInnerHTML={{ __html: adjust(post.content.rendered) }} />
            </div>
          );
        })}
      </div>
    );
  }
}
